export const toggleButtonContainerStyle = {
  width: "100%",
  display: "flex",
  flex: "1",
  justifyContent: "space-between",
  backgroundColor: "#F4EFEB",
  padding: 0.5,
  borderRadius: "0.9375rem",
  marginTop: 2,
  border: "1px solid #E0E0E0",
};

export const buttonStyle = {
  textAlign: "center",
  width: "50%",
  height: "2rem", borderRadius: "0.5rem",
  textTransform: "capitalize",
};
